/**
 * Mega panel tabs: outer pill bar and per-tab rails, click switching.
 */
export function initNavMega() {
  document.querySelectorAll('.mdh__mega').forEach((mega) => {
    wire(mega.querySelector('.mdh__mega-tabs'), mega.querySelectorAll(':scope > .mdh__mega-pane'));
    mega.querySelectorAll('.mdh__mega-pane--railed').forEach((pane) => {
      wire(pane.querySelector('.mdh__mega-rail'), pane.querySelectorAll('.mdh__mega-group'));
    });
  });

  function wire(tablist, panes) {
    if (!tablist) {
      return;
    }
    const tabs = Array.from(tablist.querySelectorAll('button'));
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach((other, j) => other.setAttribute('aria-selected', String(i === j)));
        panes.forEach((pane, j) => {
          pane.hidden = i !== j;
        });
      });
    });
  }
}
